import React from 'react';

interface EqxPatchProps {
    colour?: string;
    size?: string | number; // Optional: allow overriding size, defaults to 1em
}

/**
 * EqxPatch renders an inline circle in the given colour, matching the font height.
 */
const EqxPatch: React.FC<EqxPatchProps> = ({ colour, size = '1em' }) => (
    <span
        style={{
            display: 'inline-block',
            verticalAlign: 'middle',
            width: size,
            height: size,
            borderRadius: '50%',
            backgroundColor: colour || '#999',
            marginTop: "-3px",
            marginRight: '0.3em',
        }}
        aria-label="colour patch"
    />
);

export default EqxPatch; 